import * as React from "react";
import { forwardRef } from "react";
const SvgWarning = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 21, height: 20, viewBox: "0 0 21 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", "data-svgr-icon": "true", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M10.667 1.667A8.336 8.336 0 0 0 2.333 10c0 4.6 3.734 8.333 8.334 8.333S19 14.6 19 10s-3.733-8.333-8.333-8.333m0 9.166A.836.836 0 0 1 9.833 10V6.667c0-.459.375-.834.834-.834s.833.375.833.833V10a.836.836 0 0 1-.833.833m.833 3.333H9.833V12.5H11.5z", fill: "#EA5353" }));
const ForwardRef = forwardRef(SvgWarning);
export { ForwardRef as ReactComponent };
